"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CopyIcon = function CopyIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.6665 1.66675H8.33317C7.414 1.66675 6.6665 2.41425 6.6665 3.33341V6.66675H3.33317C2.414 6.66675 1.6665 7.41425 1.6665 8.33342V16.6667C1.6665 17.5859 2.414 18.3334 3.33317 18.3334H11.6665C12.5857 18.3334 13.3332 17.5859 13.3332 16.6667V13.3334H16.6665C17.5857 13.3334 18.3332 12.5859 18.3332 11.6667V3.33341C18.3332 2.41425 17.5857 1.66675 16.6665 1.66675ZM3.33317 16.6667V8.33342H11.6665L11.6682 16.6667H3.33317ZM16.6665 11.6667H13.3332V8.33342C13.3332 7.41425 12.5857 6.66675 11.6665 6.66675H8.33317V3.33341H16.6665V11.6667Z",
    fill: color
  }));
};

var _default = CopyIcon;
exports.default = _default;